import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import type { PricingsFiltersApi } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizePricings } from './normalize';

export const fetchPricings = createProvider(
  (filters: PricingsFiltersApi, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchPricings(filters, { signal }),
)
  .andThen(normalizePricings)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch pricing search is aborted');
    } else {
      showNotification({ message: 'Fetch pricing search was failed', type: NOTIFICATION_TYPES.ERROR });
      logger.error(`Fetch pricing search was failed: ${error}`);
    }
    throw error;
  });

export const pricingSearchOptions = (filters?: PricingsFiltersApi) =>
  queryOptions({
    enabled: Boolean(filters),
    queryFn: ({ signal }) => {
      if (!filters) {
        throw new Error('Pricing search filters are required');
      }

      return fetchPricings(filters, { signal });
    },
    queryKey: CACHE_KEYS.pricingSearch(filters),
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60,
  });
